import packageJson from '../package.json';

export const UTMCookieSettings = {
    secure: process.env.SECURE_COOKIES === 'true',
    expires: 30,
    domain: process.env.COOKIE_DOMAIN as string,
};

export const APP_VERSION = packageJson && packageJson.version;
